import React from 'react'
import { X } from 'react-feather'
import { Carousel } from '.'

const GalleryPopup = ({onClose, isMobile, images, initialSlide}) => {
  const handleClose = (e) => {
    e.preventDefault()
    e.stopPropagation()

    onClose(false)
  }

  return (
    <div
      className="fixed left-0 top-0 w-full h-screen flex justify-center items-center"
      style={{zIndex: 900, background: 'rgba(0, 0, 0, 0.75)', animation: 'darkFadeIn 0.1s ease-in-out'}}
      onClick={handleClose}
    >
      <X color="#fff" className="absolute top-0 right-0 m-5 cursor-pointer" onClick={handleClose}/>
      <div className="container mx-auto" onClick={handleClose}>
      {/* pt-8 pb-5 lg:pt-20 lg:pb-20 px-5 lg:px-24 bg-white*/}
        <div className="lg:w-10/12 mx-auto rounded" onClick={(e) => e.stopPropagation()} style={{animation: 'scaleIn 0.2s cubic-bezier(.4,1.13,.85,.85)'}}>
          <Carousel images={images} initialSlide={initialSlide} isMobile={isMobile}/>
        </div>
      </div>
    </div>
  )
}

export { GalleryPopup }
